import { FC, useEffect } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import EfImg from 'elem/ui/ef-img';
import EfButton from '@elem/ui/ef-button';
import { useGlobal } from '@/utils/useGlobal';

// 该时间点前为learn more 之后为buy now
const BUY_NOW_TIME = new Date('2024/09/10 15:00:00 GMT+8').getTime();
const CA_PRODUCT_LIST = new Date('2025/09/29 15:00:00 GMT+8').getTime();

const ShopList: FC = () => {
    const { getSystemTime, useRouter } = useGlobal();
    const router = useRouter();
    const { t } = useLang('tradein.shop_list');
    const isLearnMore = getSystemTime() < BUY_NOW_TIME;
    let systemTime = getSystemTime();
    const { locale } = getLocal();
    let productList = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723457212449/sl_dpu_1%2B1.png',
            name: 'EcoFlow DELTA Pro Ultra',
            url: `https://${locale}.ecoflow.com/products/delta-pro-ultra`,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723457197947/sl_DP3.png',
            name: 'EcoFlow DELTA Pro 3',
            url: `https://${locale}.ecoflow.com/products/delta-pro-3-portable-power-station`,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723457171683/sl_d3p.png',
            name: 'EcoFlow DELTA 3 Plus',
            url: `https://${locale}.ecoflow.com/products/delta-3-series-portable-power-station`,
            learnUrl: `https://www.ecoflow.com/${locale}/delta-3-series-portable-power-station`,
        },
    ];
    const ca_ca_productList_0929 = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1757993530101/20250916-112942.png',
            name: 'EcoFlow DELTA 3 Max (2048Wh)',
            url: `https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station`,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1757993529889/20250916-112947.png',
            name: 'EcoFlow DELTA 3 Ultra Plus (3072Wh)',
            url: `https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station`,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1757993673033/20250916-112937.png',
            name: 'EcoFlow DELTA 3 Classic (1024Wh)',
            url: `https://ca.ecoflow.com/products/delta-3-classic-portable-power-station`,
        },
    ];
    const ca_productList = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723457171683/sl_d3p.png',
            name: 'EcoFlow DELTA 3 Plus',
            url: `https://ca.ecoflow.com/products/delta-3-plus-portable-power-station`,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1756870513702/20250903-103313.png',
            name: 'EcoFlow DELTA 2 Max',
            url: `https://ca.ecoflow.com/products/delta-2-max-portable-power-station`,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723457212449/sl_dpu_1%2B1.png',
            name: 'EcoFlow DELTA Pro Ultra',
            url: `https://ca.ecoflow.com/products/delta-pro-ultra`,
        },
    ];

    const { _timer } = router.query;
    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }
    const is_0929 = systemTime >= CA_PRODUCT_LIST;

    if (locale === 'ca' && is_0929) {
        productList = ca_ca_productList_0929;
    } else if (locale === 'ca') {
        productList = ca_productList;
    }

    return (
        <div className={`${styled.ShopList} ef-container`}>
            <div className="tradein-spaec"></div>
            <h6 className="shop_list_title">{locale === 'ca' && is_0929 ? t('shop_list_title2') : t('shop_list_title')}</h6>
            <ul className="shop_list">
                {productList.map((item, index) => (
                    <li className="shop_item" key={index}>
                        <EfImg className="shop_item_img" pc={item.img} />
                        <p className="shop_item_title">{item.name}</p>
                        {item.learnUrl && isLearnMore ? (
                            <EfButton theme="black" type="buy_now" href={item.learnUrl}>
                                Learn More
                            </EfButton>
                        ) : (
                            <EfButton theme="black" type="buy_now" href={item.url}>
                                Buy Now
                            </EfButton>
                        )}
                    </li>
                ))}
            </ul>
            <a className="shop_link" href={`https://${locale}.ecoflow.com`} target="_blank" rel="noreferrer">
                {t('shop_list_link')}
            </a>
        </div>
    );
};

export default ShopList;
